export default __webpack_public_path__ + "static/media/bobo-landing.5d33b7c5.png";